module.exports = __webpack_public_path__ + "img/more.561ded7a.png";